<template>
  <div id="notifications" v-show="Object.keys(queue).length">
    <transition-group appear name="fade">
      <div v-for="(notificationId) in sortedQueue" :key="notificationId" :class="['notification', queue[notificationId]['type']]">
        <p class="title">{{ queue[notificationId].title }}</p>
        <p class="body">{{ queue[notificationId].body }}</p>
        <i class="fas fa-close" @click="closeNotification(notificationId)"></i>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'notifications',

  data () {
    return {
      queue: {},
      intervals: [],
      timeout: 3000
    }
  },

  mounted () {
    let that = this

    this.$bus.on('addNotification', function (data) {
      that.queue = {}
      const id = Date.now()
      if (typeof data.type === 'undefined') data['type'] = 'default'
      window.Vue.set(that.queue, id, data)
      const interval = setTimeout(function () {
        that.closeNotification(id)
      }, 2500)
      that.intervals.push(interval)
    })
  },

  methods: {
    closeNotification (id) {
      clearTimeout(id)
      window.Vue.delete(this.intervals, id)
      window.Vue.delete(this.queue, id)
    }
  },

  computed: {
    sortedQueue: function () {
      let keys = Object.keys(this.queue)
      keys.sort()
      return keys
    }
  },

  beforeDestroy () {
    this.$bus.$off('addNotification')
  }
}
</script>

<style lang="scss" scoped>
  #notifications {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 425px;
    height: 90px;
    z-index: 1055;
    transform: translate(-50%);

    .notification {
      text-align: left;
      position: relative;
      border: 1px solid black;
      border-radius: 10px;
      background-color: #6c757d;
      padding:  15px 15px 15px 35px;
      margin-top: 10px;
      color: #FFF;
      transition: opacity 0.3s linear;

      &.error {
        background-color: #dc3545;
      }

      &.success {
        background-color: #3bbb59;
      }

      &.info {
        background-color: #cccccc;
        color: #000;
      }

      &:last-of-type {
        border-bottom: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      p {
        margin: 0;
      }

      .title {
        font-weight: bold;
        text-align: center;
        padding-bottom: 10px;
      }

      .body {
        font-weight: normal;
        text-align: center;
        padding-bottom: 10px;
      }

      .fa-close {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .fade-enter-active, .fade-leave-active {
      opacity: 1;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/editor/main/Notifications.vue